<template>
  <div id="modem">
    <router-view/>
  </div>
</template>

<script>
export default {
  mounted () {
    this.$emit('setMenu', 'Modem')
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modemInfo/Modem.vue